import { StateType } from 'data/types'

import { CurrencyPaymentMethodsStateType } from './reducers'

const getPaymentMethodsStateForCurrency = (state: StateType, currency: string) =>
  state.payments.methods[currency]

// get a currency => data map
const getPaymentMethodsByCurrency = (state: StateType) => {
  const currencies = Object.keys(state.payments.methods)
  return currencies.reduce((grouped, currency) => {
    const currencyState = getPaymentMethodsStateForCurrency(state, currency as string)
    if (!currencyState || !currencyState.data) return grouped
    return {
      ...grouped,
      [currency]: currencyState.data
    }
  }, {})
}

// is any payment method being fetched?
const arePaymentMethodsLoading = (state: StateType) =>
  Object.values<CurrencyPaymentMethodsStateType>(state.payments.methods)
    .map((pmState) => pmState.loading)
    .reduce((a, b) => a || b, false)

export default {
  arePaymentMethodsLoading,
  getPaymentMethodsByCurrency
}
